const order = {
    state: {
        cartList: ''
    },
    mutations: {
        addCartList: (state,val) => {
            state.cartList = val
        }
    },
    action: {
        getCartList({commit},data) {
            commit('addCartList',data)
        }
    }
}

export default order